import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";

/**
 * The legacy medication-tracking feed — READ ONLY.
 *
 * This is the data bridge's Tracking 2.0 "Medications" panel shows. It is not
 * the v2 medicines model: each entry is a POST — one author, one timestamp, and
 * a whole numbered medicine list as it stood at that moment — so the same drug
 * appears in every snapshot it was part of. There are no per-medicine ids and
 * no per-medicine status.
 *
 * Only reads are wired. The legacy block also carries an `add` endpoint; it is
 * deliberately absent from this module's config so this view cannot write even
 * by accident.
 */
class OldMedicineService {
  constructor() {
    this.apiService = new APIService();
  }

  /** Total number of tracking entries. Responds with a bare number. */
  count(patientId, onResponse, onError) {
    return this.apiService.get(
      APIConfig.tracking.medicine.count.format(patientId),
      onResponse,
      onError
    );
  }

  /**
   * One page of entries, newest first.
   *
   * pageSize 3 matches the legacy screen (new-bridge/index.js:541-546). Note
   * its SHOW MORE never compares the loaded count to the total — it just keeps
   * asking; this caller compares, so the button disappears when the feed is
   * exhausted.
   */
  list(patientId, pageNo, pageSize, onResponse, onError) {
    return this.apiService.get(
      APIConfig.tracking.medicine.list.format(patientId, pageSize, pageNo),
      onResponse,
      onError
    );
  }

  /** MEDICINE_FORMULATIONS / MEDICINE_INSTRUCTIONS / MEDICINE_TIMEPERIOD.
   *  phr already had this list wired under detailedAssessment.getDataTables. */
  referenceLists(onResponse, onError) {
    return this.apiService.get(APIConfig.referenceList.getAllDetails, onResponse, onError);
  }

  /** Salt units, keyed by `code`. */
  saltUnits(onResponse, onError) {
    return this.apiService.get(APIConfig.medicineSalt, onResponse, onError);
  }
}

export default OldMedicineService;
